var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('landing-create', {
    attrs: {
      "content": _vm.content
    }
  }), _vm.protocolNumber ? _c('protocol-number-form', {
    attrs: {
      "isLoading": _vm.isLoading,
      "onSubmit": _vm.onSubmit,
      "protocolNumber": _vm.protocolNumber
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }